// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__7BKvz","iconUser":"User_iconUser__1Rjkz"};